import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  styled,
  TextField,
  FormHelperText,
  Stack,
  Button,
  CircularProgress,
  MenuItem,
} from "@mui/material";
import BannerImage from "..//professionalTournaments/BannerImage";
import YTVideo from "..//professionalTournaments/YTVideo";
import GoalVideoUpload from "../professionalTournaments/GoalVideoUpload";
import { useSelector } from "react-redux";
import ProfessionalGoalVideosForm from "../professionalTournaments/ProfessionalGoalsForm/Index";
import { generateRandomNumber } from "../../../helper/generateRandom";
import { toast } from "react-toastify";
import { useAuth } from "../../../context/auth";
const CustomTextarea = styled(TextField)(() => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    color: "black",
    padding: "10px 15px",
    "&:hover": {
      backgroundColor: "transparent",
      border: "1px solid #e5e7eb",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      border: "1px solid #e5e7eb",
      outline: "none",
    },
  },

  "& .MuiInputBase-input": {
    padding: "0",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

const ProfessionalTournamentForm = ({
  formik,
  edited,
  setDeletedVideos,
  goalVideos,
  setGoalVideos,
}) => {
  const goalCategories = useSelector((state) => state.goalCategories);

  const [goalLoading, setGoalLoading] = useState(false);

  return (
    <Box className="page_inner">
      <form onSubmit={formik.handleSubmit}>
        <Box className="professional-tournament-form">
          <Box className="category form-control">
            <Typography className="label">Title</Typography>
            <CustomTextarea
              variant="outlined"
              name="title"
              value={formik.values.title}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter Title"
            />
            {formik.touched.title && formik.errors.title ? (
              <FormHelperText sx={{ color: "red" }}>
                {formik.errors.title}
              </FormHelperText>
            ) : (
              ""
            )}
          </Box>

          <Box className="category form-control">
            <Typography className="label">Description</Typography>
            <CustomTextarea
              variant="outlined"
              multiline
              rows={3}
              name="description"
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter Description"
            />
            {formik.touched.description && formik.errors.description ? (
              <FormHelperText sx={{ color: "red" }}>
                {formik.errors.description}
              </FormHelperText>
            ) : (
              ""
            )}
          </Box>

          <Box className="category form-control">
            <Typography className="label">Youtube Link</Typography>
            <CustomTextarea
              variant="outlined"
              name="yt_link"
              value={formik.values.yt_link}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter Youtube Link"
            />
            {formik.touched.yt_link && formik.errors.yt_link ? (
              <FormHelperText sx={{ color: "red" }}>
                {formik.errors.yt_link}
              </FormHelperText>
            ) : (
              ""
            )}
          </Box>

          <Box className="category form-control">
            <Stack direction="row" sx={{ gap: "20px" }}>
              <Box className="banner_field">
                <Typography className="label">Banner Image</Typography>
                <Box className="Banner_img_preview">
                  <BannerImage formik={formik} />
                  {formik.touched.image && formik.errors.image ? (
                    <FormHelperText sx={{ color: "red" }}>
                      {formik.errors.image}
                    </FormHelperText>
                  ) : (
                    ""
                  )}
                </Box>
              </Box>

              {/* professional tournament youtube video  */}
              <Box className="banner_field">
                <Typography className="label">Compilation Video</Typography>

                <Box className="Banner_img_preview">
                  <YTVideo formik={formik} edited={edited} />
                </Box>
              </Box>
            </Stack>
          </Box>

          <Box className="category form-control">
            <Typography className="label">Upload Goals Videos</Typography>
            <Box className="goal_videos_preview">
              <ProfessionalGoalVideosForm
                setDeletedVideos={setDeletedVideos}
                goalVideos={goalVideos}
                setGoalVideos={setGoalVideos}
              />
              <Button
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  color: "#6b7280",
                  padding: "8px 13px",
                  marginTop: "20px",
                }}
                onClick={() => {
                  if (goalLoading) {
                    return;
                  }

                  if (goalVideos.length >= 50) {
                    toast.error("Maximum limit has been reached!!");
                    return;
                  }

                  setGoalVideos((prev) => {
                    return [
                      ...prev,
                      {
                        key_Id: generateRandomNumber(5),
                        club_name: "",
                        goal_scorer: "",
                        goal: null,
                        goal_image: null,
                        validated: false,
                        error: "",
                      }
                    ];
                  });
                }}
              >
                Add More Goals
              </Button>
            </Box>
          </Box>

          <Box className="category form-control">
            <Button
              className="pt-create"
              onClick={() => {
                formik.handleSubmit();
              }}
            >
              {edited ? "Update" : "Create"}
            </Button>
          </Box>
        </Box>
      </form>
    </Box>
  );
};

export default ProfessionalTournamentForm;
